import * as React from "react";
import {Grid2 as Grid} from "@mui/material";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {CardEx} from "@/lib/components/CardEx";
import {useTranslation} from "react-i18next";
import {RequestI18N} from "@/translations";

export type CancellationReasonCardProps = {
    cancellationReason?: string | null;
};

export const CancellationReasonCard = ({ cancellationReason }: CancellationReasonCardProps) => {
    const { t } = useTranslation();

    // Nur anzeigen, wenn ein Grund vorhanden ist
    if (!cancellationReason?.trim()) {
        return null;
    }

    return (
            <CardEx title={t(RequestI18N.details.page.cancellationReasonCardTitle)}>
            <Grid container spacing={2}>
                <Grid size={{ sm: 12 }}>
                    <StringInputField
                            label={t(RequestI18N.details.field.cancellationReason)}
                            value={cancellationReason.trim() || t(RequestI18N.details.message.noCancellationReason)}
                        multiline
                        minRows={3}
                        disabled
                    />
                </Grid>
            </Grid>
        </CardEx>
    );
};
